import { render } from "./FlowbiteStatsIcon.vue?vue&type=template&id=3a80699c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__